<template>
	<div class="grid-flex-container" v-if="report">
		<v-container fluid class="py-0">
			<v-row no-gutters>
				<v-col>
					<v-text-field
						label="Report Name"
						disabled
						v-model="report.Name"
					/>
				</v-col>
				<v-col class="ml-2">
					<v-select
						disabled
						label="Report Type"
						item-value="value"
						item-text="label"
						:items="reportTypeItems"
						v-model="report.Type"
					/>
				</v-col>
				<v-col class="ml-2" v-if="hasCustomData">
					<v-text-field
						label="Data Source"
						disabled
						v-model="report.CustomData"
					/>
				</v-col>
				<v-col v-else class="ml-2">
					<v-select
						disabled
						:items="gridViews"
						item-value="Id"
						item-text="Name"
						label="Data Source"
						v-model="report.GridViewId"
					/>
				</v-col>
				<!-- "Visible to all users" lives on top of the Assign Users tab -->
				<v-col class="ml-2 my-2">
					<v-btn color="primary" @click="onEdit" class="float-right">
						<v-icon class="mr-1">mdi-pencil</v-icon>Edit
					</v-btn>
				</v-col>
				<report-modal
					:showDialog="showReportModal"
					:report="report"
					@close="onCloseReportModal"
				/>
			</v-row>
		</v-container>

		<v-tabs
			class="mx-4"
			v-model="tab"
			center-active
			show-arrows
			style="flex: none"
		>
			<v-tab>Fields</v-tab>
			<v-tab v-if="!hasCustomData">Filters</v-tab>
			<v-tab v-if="!hasCustomData">Sorting</v-tab>
			<v-tab>Preview</v-tab>

			<v-tab v-if="false">Properties</v-tab>
			<v-tab v-if="canViewUserAssign">Assign Users</v-tab>
		</v-tabs>

		<report-fields v-if="tab === 0" />
		<report-filters v-if="tab == 1 && !hasCustomData" />
		<report-sorting v-if="tab == 2 && !hasCustomData" />

		<div
			class="tabContainer px-3"
			v-if="tab === 3 || (tab === 1 && hasCustomData)"
		>
			<report-preview
				v-if="tab === 3 || (tab === 1 && hasCustomData)"
				:report="report"
			/>
			<v-container fluid class="mt-2">
				<v-row no-gutters>
					<v-spacer />
					<v-btn text outlined @click="onCancel">Cancel</v-btn>
				</v-row>
			</v-container>
		</div>
		<report-properties v-if="tab === 5" />
		<report-assign-users
			v-if="showAssignUsersTab"
			:visibleToAllUsers="previewIsVisible"
			@visible-to-all-users-changed="onPreviewIsVisibleChanged"
		/>
	</div>
</template>
<script>
import ReportModal from '../ReportModal.vue';
import { reportTypes } from '../../../../enums/reportTypes';
import { mapGetters } from 'vuex';
import { ReportDetailsActions } from '../../../../store/actions';
import { ReportDetailsGetters } from '../../../../store/getters';
import ReportProperties from './reportProperties/ReportProperties.vue';
import ReportFields from './reportFields/ReportFields.vue';
import ReportFilters from './reportFilters/ReportFilters.vue';
import ReportSorting from './reportSorting/ReportSorting.vue';
import ReportPreview from './reportPreview/ReportPreview.vue';
import ReportAssignUsers from './assignUser/ReportAssignUser.vue';
import { Permissions } from '../../../../enums/permissionsEnum';
import permissionsMixin from '../../../../mixins/permissionsMixin';
export default {
	components: {
		ReportModal,
		ReportFields,
		ReportFilters,
		ReportSorting,
		ReportProperties,
		ReportPreview,
		ReportAssignUsers,
	},
	name: 'ReportDetails',
	mixins: [permissionsMixin],
	computed: {
		showAssignUsersTab() {
			if (this.hasCustomData) {
				return this.tab == 2;
			} else {
				return this.tab == 4;
			}
		},

		reportId() {
			if (
				this.$route &&
				this.$route.params &&
				this.$route.params.reportId
			)
				return this.$route.params.reportId;
			return null;
		},
		hasCustomData() {
			if (!this.report) return null;
			if (!this.report.Type) return false;
			return this.report.Type == reportTypes.CUSTOM_DATA;
		},
		...mapGetters({
			report: [ReportDetailsGetters.REPORT],
			gridViews: [ReportDetailsGetters.DATA_SOURCES_RAW_DATA],
		}),
		canViewUserAssign() {
			return this.hasPermissions([
				Permissions.Tools.ReportBuilder.Report.AssignUser.View,
			]);
		},
	},
	data() {
		return {
			reportTypeItems: [
				{ label: 'Default Data', value: reportTypes.RAW_DATA },
				{ label: 'Custom Data', value: reportTypes.CUSTOM_DATA },
			],
			previewIsVisible: false,
			showReportModal: false,
			tab: 0,
		};
	},
	mounted() {
		this.$store.dispatch(ReportDetailsActions.LOAD_GRIDVIEWS);
		if (this.reportId) {
			this.$store
				.dispatch(ReportDetailsActions.LOAD_REPORT, this.reportId)
				.then(() => {
					if (
						this.report &&
						this.report.Type == reportTypes.RAW_DATA
					) {
						this.previewIsVisible = this.report.PreviewIsVisible;
					} else {
						this.previewIsVisible = this.report.Active;
					}
				});
		}
	},
	destroyed() {
		this.$store.dispatch(ReportDetailsActions.CLEAR);
	},
	methods: {
		onCancel() {
			this.$router.push({ name: 'ReportBuilder' });
		},
		onCloseReportModal() {
			this.showReportModal = false;
		},
		onEdit() {
			this.showReportModal = true;
		},
		onPreviewIsVisibleChanged(isVisible) {
			// the switch on the Assign Users tab is controlled, it only reports the new value
			this.previewIsVisible = !!isVisible;
			this.$store
				.dispatch(ReportDetailsActions.UPDATE_PREVIEW_VISIBILITY, {
					reportId: this.report.Id,
					isVisible: this.previewIsVisible,
				})
				.then((resp) => {
					if (!resp) this.previewIsVisible = !this.previewIsVisible;
				});
		},
	},
};
</script>

<style lang="scss">
.v-tabs-bar {
	height: 41px;
}
</style>

<style lang="scss" scoped>
.tabContainer {
	display: flex;
	flex-direction: column;
	overflow: hidden;
	height: 100%;

	.tabInnerContainer {
		flex-grow: 1;
	}
}
</style>
